import React from "react";
import ListingGridSkeleton, { ShimmerLine } from "../Skeleton/ListingGridSkeleton";
import "../Skeleton/shimmer.css";

/**
 * Lightweight placeholder blocks for home feed loading (replaces spinners).
 */
export default function HomeSectionsSkeleton({ sections = 4, className = "" }) {
  return (
    <div
      className={`home-sections-skeleton page-shell-x py-8 ${className}`}
      aria-busy="true"
      aria-label="Loading content"
    >
      {Array.from({ length: sections }).map((_, i) => (
        <div key={i} className="mb-10 sm:mb-12">
          <ShimmerLine className="mb-4" width="10rem" style={{ height: "1rem" }} />
          <ListingGridSkeleton count={3} />
        </div>
      ))}
    </div>
  );
}
